import React, { Component, Fragment } from "react";
import AUX from "../../hoc/Aux_";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import axios from "../Shared/auth-header";
import $ from "jquery";
import { toast } from "react-toastify";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

class RolesLookup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            sizePerPage: 10,
            data: [],
            rolesMethods: this.props.rolesMethods
        };
        this.rowEvents = {
            onClick: (e, row, rowIndex) => {
                this.state.rolesMethods().updateRole(row);
            }
        };
        this.columns = [
            {
                text: "Role Name",
                dataField: "name",
                sort: true
            },
            {
                text: "Description",
                dataField: "description",
                sort: true
            }
        ];
        this.RemotePagination = (data, page, sizePerPage, onTableChange, totalSize, showTotal, rowEvents) => (
            <div>
                <BootstrapTable
                    remote
                    keyField="id"
                    data={data}
                    columns={this.columns}
                    pagination={paginationFactory({ page, sizePerPage, totalSize, showTotal })}
                    onTableChange={onTableChange}
                    rowEvents={rowEvents}
                />
            </div>
        );
    }
    handleTableChange = (type, { sortField, sortOrder, data, page, sizePerPage }) => {
        let url = `/api/Role/GetRoles`;
        if (type === "sort") {
            this.state.SortOrder = sortField + sortOrder;
            this.setState({ SortOrder: this.state.SortOrder });
        }
        const formData = {
            PageNo: page,
            PageSize: sizePerPage,
            SortOrder: this.state.SortOrder,
            Keyword: $("#keyword").val(),
            Name: "",
            MemberName: "",
            PositionName: "",
            OperatorType: "AND",
        };

        $(".loading").show();

        axios.post(url, formData).then(({ data }) => {
            if (data.status && data.status.toLowerCase() == "success") {
                this.setState({
                    data: data.data,
                    totalCount: data.totalCount,
                    page,
                    sizePerPage
                });
                $(".loading").hide();
            } else {
                $(".loading").hide();
                toast.error(data.message);
            }
        });
    };
    handleFormSearch(e) {
        e.preventDefault();
        $(".loading").show();
        let url = `/api/Role/GetRoles`;
        const formData = {
            PageNo: 1,
            PageSize: 10,
            SortOrder: this.state.SortOrder,
            Keyword: $("#keyword").val(),
            Name: "",
            MemberName: "",
            PositionName: "",
            OperatorType: "AND",
        };

        axios.post(url, formData).then(({ data }) => {
            if (data.status && data.status.toLowerCase() == "success") {
                this.setState({
                    data: data.data,
                    totalCount: data.totalCount,
                    page: 1
                });
                $(".loading").hide();
            } else {
                $(".loading").hide();
                toast.error(data.message);
            }
        });
    }
    componentWillMount() {
        $(".loading").show();
        const url = `/api/Role/GetRoles`;
        const formData = {
            PageNo: 1,
            PageSize: 10,
            Keyword: $("#keyword").val(),
            Name: "",
            MemberName: "",
            PositionName: "",
            OperatorType: "AND",
            SortOrder: "NameAsc"
        };
        axios.post(url, formData).then(({ data }) => {
            if (data.status && data.status.toLowerCase() == "success") {
                this.setState({ data: data.data, totalCount: data.totalCount, });
                $(".loading").hide();
            } else {
                $(".loading").hide();
                toast.error(data.message);
            }
        });
    }
    render() {
        const { data, sizePerPage, page, totalCount } = this.state;
        const showTotal = true;
        return (
            <AUX>
                <div className="container-fluid">
                    <div className="page-title-box">
                        <div className="row align-items-center">
                            <div className="col-sm-6">
                                <h4 className="page-title">Roles</h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <ToolkitProvider keyField="id" columns={this.columns} >
                                {props => (
                                    <Fragment>
                                        <div className="d-flex justify-content-center mb-2">
                                            <div className="col-6 text-center app-search">
                                                <form role="search" className="app-search mt-0" onSubmit={this.handleFormSearch}>
                                                    <div className="form-group mb-0">
                                                        <input
                                                            type="text"
                                                            id="keyword"
                                                            className="form-control mb-1 w-100"
                                                            placeholder="Search.."
                                                        />
                                                        <button type="submit">
                                                            <i className="fa fa-search" />
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                {this.RemotePagination(data, page, sizePerPage, this.handleTableChange, totalCount, showTotal, this.rowEvents)}
                                            </div>
                                        </div>
                                    </Fragment>
                                )}
                            </ToolkitProvider>
                        </div>
                    </div>
                </div>
            </AUX>
        );
    }
}

export default RolesLookup;
